const LOG_LEVELS = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
};

const CURRENT_LEVEL =
    process.env.NODE_ENV === 'production' ? LOG_LEVELS.info : LOG_LEVELS.debug;

const formatMessage = (level, message, meta) => {
    const timestamp = new Date().toISOString();
    const base = `[${timestamp}] [${level.toUpperCase()}] ${message}`;
    if (meta === undefined) {
        return base;
    }
    return { message: base, meta };
};

const loggerHelper = {
    debug(message, meta) {
        if (CURRENT_LEVEL > LOG_LEVELS.debug) return;
        const formatted = formatMessage('debug', message, meta);
        if (typeof formatted === 'string') {
            // eslint-disable-next-line no-console
            console.debug(formatted);
        } else {
            // eslint-disable-next-line no-console
            console.debug(formatted.message, formatted.meta);
        }
    },

    info(message, meta) {
        if (CURRENT_LEVEL > LOG_LEVELS.info) return;
        const formatted = formatMessage('info', message, meta);
        if (typeof formatted === 'string') {
            // eslint-disable-next-line no-console
            console.info(formatted);
        } else {
            // eslint-disable-next-line no-console
            console.info(formatted.message, formatted.meta);
        }
    },

    warn(message, meta) {
        if (CURRENT_LEVEL > LOG_LEVELS.warn) return;
        const formatted = formatMessage('warn', message, meta);
        if (typeof formatted === 'string') {
            // eslint-disable-next-line no-console
            console.warn(formatted);
        } else {
            // eslint-disable-next-line no-console
            console.warn(formatted.message, formatted.meta);
        }
    },

    error(message, meta) {
        const formatted = formatMessage('error', message, meta);
        if (typeof formatted === 'string') {
            // eslint-disable-next-line no-console
            console.error(formatted);
        } else {
            // eslint-disable-next-line no-console
            console.error(formatted.message, formatted.meta);
        }
    },
};

export default loggerHelper;
